import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["search", "category", "item"]

  filter() {
    const query = this.searchTarget.value.toLowerCase()

    this.itemTargets.forEach(item => {
      const name = item.dataset.name?.toLowerCase() || ""
      const matches = name.includes(query)
      item.classList.toggle("hidden", !matches)
    })

    // カテゴリの表示/非表示を更新
    this.categoryTargets.forEach(category => {
      const visibleItems = category.querySelectorAll('[data-checkbox-group-target="item"]:not(.hidden)')
      category.classList.toggle("hidden", visibleItems.length === 0)
    })
  }
}
